module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD3SURBVHgB5VPtDYJADH04ASN0BDZAN3AD2UA20A1wA+IGboAbOAJsABvoXWhDUXqcif98yctBWh6vHwfMkToeHRvH3vHJp38/4Etkji2LWHw4UqxYrz6s2VGuHEus5UqCaFVyZuSUSrQJiRUqkRCGFt1aSVJOjThINdVScIOpxBviIHlkCUqDB8RB8lJLcAj9cQH0JvwB6WFwcgrSQ3PRC0yTW7sNZ0RuhLj0y10uxH2/LkqssoQSPolFid87jNMcWKzAfAg+vuPTBGHcResee/cnzG8VWQ41csc9pv30Lu+OV34mVU0X4zQGtOb0j0QT/AaEcVDdC5P8YoVrl9bgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/search.png
// module id = 1356
// module chunks = 7